import { render, staticRenderFns } from "./field-validation-list.vue?vue&type=template&id=a3900bf4&"
import script from "./field-validation-list.vue?vue&type=script&lang=js&"
export * from "./field-validation-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports